import { atom, useAtom } from 'jotai';
import { CJEvent, CJEventStatus } from 'types/event';

export type ActionHistory =
  | {
      action: 'CREATE' | 'DELETE' | 'UPDATE' | 'RESTORE';
      payload: CJEvent | CJEvent[];
    }
  | {
      action: 'UPDATE_STATUS';
      payload: {
        status: CJEventStatus;
        date: Date;
      };
    };

export const futureAtom = atom<Array<ActionHistory>>([]);
export const pastAtom = atom<Array<ActionHistory>>([]);
export const MAX_HISTORY_SIZE = 20;

export function useCJHistory() {
  const [past, setPast] = useAtom(pastAtom);
  const [future, setFuture] = useAtom(futureAtom);

  return {
    resetFuture: () => setFuture([]),
    addToPast: (v: ActionHistory) =>
      setPast([...past.slice(MAX_HISTORY_SIZE * -1), v]),
    isFutureEmpty: future.length === 0,
    isPastEmpty: past.length === 0,
  };
}

export const addToCJPastAtom = atom(null, (get, set, v: ActionHistory) => {
  const past = get(pastAtom);
  set(pastAtom, [...past.slice(MAX_HISTORY_SIZE * -1), v]);
  return set(futureAtom, []);
});
